import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Login from "./pages/Login";
import Error from "./pages/Error";
import Contact from "./pages/Contact";
import Products from "./pages/Products";
import Sharedlayout from "./pages/components/SharedLayout";
import Footer from "./pages/components/Footer";
import SingleProduct from "./pages/SingleProduct";
import Dashboard from "./pages/Dashboard";
import { useState } from "react";
import ProtectedRoute from "./pages/ProtectedRoute";
import SharedProductLayout from "./SharedProductLayout";

function App() {
  const [user, setUser] = useState(null);
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Sharedlayout />}>
            {/* Shared Routes */}
            <Route index element={<Home />} />
            <Route path="about" element={<About />} />
            <Route path="contact" element={<Contact />} />
            {/* products Routes */}
            <Route path="products" element={<SharedProductLayout />}>
              <Route index element={<Products />} />
              <Route path=":productid" element={<SingleProduct />} />
            </Route>
            {/* Dashboard Login Routes */}
            <Route path="login" element={<Login setUser={setUser} />} />
            <Route
              path="dashboard"
              element={
                <ProtectedRoute user={user}>
                  <Dashboard user={user} />
                </ProtectedRoute>
              }
            />
            {/* Error Route */}
            <Route path="*" element={<Error />} />
          </Route>
        </Routes>
        <Footer />
      </BrowserRouter>
    </>
  );
}

export default App;
